import React from 'react'
import { Card, CardBody, CardHeader, Col, Row } from 'reactstrap';
import { Button } from 'semantic-ui-react'
import { MDBDataTable } from 'mdbreact'
import * as common from '../../../const/Common/CommonFunc';
import LabelDropdown from "../../../components/Dropdown/LabelDropdown/LabelDropdown";
import {connect} from "react-redux";
import * as actionCreator from "../../../store/Action";
import Cookies from "js-cookie";
import axios from "../../../axios/axios_visitortag";
import axiosTags from "../../../axios/axios_tag";
import { Empty } from "antd";
import { DatePicker } from "antd";
import moment from "moment";
import '../../../react-antd.css'
import $ from "jquery";
import Download from '../../../components/Button/DownloadbleButton'
import apiConfig from "../../../axios/axios_api_services";

const { RangePicker } = DatePicker;

function disabledDate(current) {
  return current && current > moment().endOf("day");
}

class App extends React.Component {

  state = {
    visitors_list: [],
    failed_list: [],
    spin: true,
    corporate_id: "",
    details: [],
    start_date: '',
    end_date: '',
    successColumns: [
      {
        label: 'Check In Date',
        field: 'checkInDate',
        sort: 'asc'
      },
      {
        label: 'Visitor Name',
        field: 'visitorName',
        sort: 'asc',

      },
      {
        label: 'Visitor Identifiacation',
        field: 'visitorIdentifiacation',
        sort: 'asc',

      },
      {
        label: 'Visitor Contact',
        field: 'visitorContact',
        sort: 'asc',

      },
      {
        label: 'Visitor Mail',
        field: 'visitorMail',
        sort: 'asc',

      }, {
        label: 'Visitor Purpose',
        field: 'visitorPurpose',
        sort: 'asc'
      },
      {
        label: 'Visitor Company',
        field: 'visitorCompany',
        sort: 'asc',

      },
      {
        label: 'Card Name',
        field: 'cardName',
        sort: 'asc',

      },
      {
        label: 'Receptionist Name',
        field: 'receptionistName',
        sort: 'asc',

      },
      {
        label: 'Corporate Name',
        field: 'corporateName',
        sort: 'asc',

      }
    ],

    failedColumns: [
      {
        label: 'Check In',
        field: 'checkIn',
        sort: 'asc',
      },
      {
        label: 'Visitor User Id',
        field: 'visitorUserId',
        sort: 'asc',
      },
      {
        label: 'Visitor First Name',
        field: 'visitorFirstName',
        sort: 'asc',

      },
      {
        label: 'Visitor Mobile',
        field: 'visitorMobile',
        sort: 'asc',

      },
      {
        label: 'Visitor Company',
        field: 'visitorCompany',
        sort: 'asc',

      },
      {
        label: 'visitor Email',
        field: 'visitorEmail',
        sort: 'asc',

      },
      {
        label: 'Visitor Purpose',
        field: 'visitorPurpose',
        sort: 'asc',
      },
      {
        label: 'HostA Mobile',
        field: 'hostAMobile',
        sort: 'asc',
      },
      {
        label: 'HostA Name',
        field: 'hostAName',
        sort: 'asc',
      },
      {
        label: 'HostB Mobile',
        field: 'hostBMobile',
        sort: 'asc',
      },
      {
        label: 'HostB Name',
        field: 'hostBName',
        sort: 'asc',
      },
      {
        label: 'Card Id',
        field: 'cardId',
        sort: 'asc',

      },
      {
        label: 'Card Name',
        field: 'cardName',
        sort: 'asc',

      },
      {
        label: 'Reception Name',
        field: 'receptionName',
        sort: 'asc',

      },
      {
        label: 'Corporate Name',
        field: 'corporateName',
        sort: 'asc',

      },
      {
        label: 'Reason',
        field: 'reason',
        sort: 'asc',

      },
      {
        label: 'Visitor Last Name',
        field: 'visitorLastName',
        sort: 'asc',

      },
      {
        label: 'Visitor Identity',
        field: 'visitorIdentity',
        sort: 'asc',

      }
    ]

  };

  onChange = (date, dateString) => {
    if (dateString[0] === "" || dateString[1] === "") {
    } else {
      let start = new Date(dateString[0]).getTime();
      let end = new Date(dateString[1]).getTime();
      this.setState({
        start_date: start,
        end_date: end,
      });

      if (this.props.usr_obj.userRoles !== "SYS_ADMIN") {
        this.buttonHandler(start, end);
      }
    }
  };

  getAllDetails = () => {
    this.props.spinnerHandler(true);
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    axiosTags.get(apiConfig.SERVICES, { headers: headers })
      .then(response => {
        if (response.data.success) {
          if (response.data.body.length !== 0) {
            this.setState({
              corporate_id: response.data.body[0].corporateId,
              details: response.data.body,
            });
            this.buttonHandler();
          }
        } else {
          this.setState({
            details: [],
            spin: false
          });
          this.props.spinnerHandler(false);
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getAllDetails();
        } else {
          this.props.spinnerHandler(false);
        }
      });
  };
  corporateHandler = name => (e, { value }) => {
    this.setState({
      [name]: value
    });
  };

  buttonHandler = (start, end) => {

    let { corporate_id, start_date, end_date } = this.state;
    let condition = false;
    let startDate = new Date().setDate(new Date().getDate() - 30);
    let endDate = new Date().setDate(new Date().getDate());

    if (start === undefined && end === undefined) {
      if (start_date !== "" && end_date !== "") {
        startDate = start_date;
        endDate = end_date;
      }
    } else {
      startDate = start;
      endDate = end;
    }

    if (this.props.usr_obj.userRoles !== "SYS_ADMIN") {
      corporate_id = this.props.usr_obj.corporates[0].corporateId
    }

    corporate_id === '' ? common.notifyMessage("Please select corporate") : condition = true;

    if (condition) {
      this.setState({
        spin: true
      });

      this.props.spinnerHandler(true);

      const headers = {
        "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
      };
      axios.get(apiConfig.CORPORATE_SUCCESS_VISITOR_LOGS({corporateId:corporate_id,startDate:startDate,endDate:endDate}), { headers: headers })
        .then(async response => {

          if (response.data.success) {
            this.setState({
              visitors_list: response.data.successlogs
            });
          } else {
            this.setState({
              visitors_list: []
            });
          }
        })

        .catch(async error => {
          let result = await common.checkErrorResponse(error);
          if (result === 1) {
            this.buttonHandler(start, end);
          } else {
            this.props.spinnerHandler(false)
          }
        })

        .finally(fin => {
          this.props.spinnerHandler(false);
        });

      /////////////////////////////////////////////////////////////////////////////
      axios.get(apiConfig.CORPORATE_FAILED_VISITOR_LOGS({corporateId:corporate_id,startDate:startDate,endDate:endDate}), { headers: headers })
        .then(async response => {

          if (response.data.success) {
            this.setState({
              failed_list: response.data.failLogs
            });
          } else {
            this.setState({
              failed_list: []
            });
          }
        })

        .catch(async error => {
          let result = await common.checkErrorResponse(error);
          if (result === 1) {
            this.buttonHandler(start, end);
          } else {
            this.props.spinnerHandler(false)
          }
        })

        .finally(fin => {
          this.props.spinnerHandler(false);
        });
    }
  };

  componentDidMount() {
    if (this.props.usr_obj.userRoles === "SYS_ADMIN") {
      this.getAllDetails();
    } else {
      this.buttonHandler();
    }
  }

  render() {
    let rows = [];
    let failedrows = [];
    let corporate_options = [];
    if (this.state.details.length !== 0) {
      this.state.details.map((details, index) => {
        const obj = {
          key: details.corporateId,
          text: details.corporateName,
          value: details.corporateId
        };
        corporate_options.push(obj)
      })
    }
    if (this.state.visitors_list.length !== 0) {
      this.state.visitors_list.map((value, index) => {
        rows.push(
          {

            checkInDate: value.checkInDate,
            visitorName: value.visitorName,
            visitorIdentifiacation: value.visitorIdentifiacation,
            // visitorIdentifiacationType: value.visitorIdentifiacationType,
            visitorContact: value.visitorContact,
            visitorMail: value.visitorMail,
            visitorPurpose: value.visitorPurpose,
            visitorCompany: value.visitorCompany,
            cardName: value.cardName,
            // floor: value.floor,
            receptionistName: value.receptionistName,
            corporateName: value.corporateName


          }
        )
      });
    }

    if (this.state.failed_list.length !== 0) {
      this.state.failed_list.map((value, index) => {
        failedrows.push(
          {
            checkIn: value.checkIn,
            visitorUserId: value.visitorUserId,
            visitorFirstName: value.visitorFirstName,
            visitorMobile: value.visitorMobile,
            visitorCompany: value.visitorCompany,
            visitorEmail: value.visitorEmail,
            visitorPurpose: value.visitorPurpose,
            hostAMobile: value.hostAMobile,
            hostAName: value.hostAName,
            hostBMobile: value.hostBMobile,
            hostBName: value.hostBName,
            cardId: value.cardId,
            cardName: value.cardName,
            receptionName: value.receptionName,
            corporateName: value.corporateName,
            reason: value.reason,
            visitorLastName: value.visitorLastName,
            visitorIdentity: value.visitorIdentity
          }
        )
      });
    }

    let columns = this.state.successColumns;
    let data = { columns, rows };

    let failcol = this.state.failedColumns;
    let faileddata = { columns:failcol, rows:failedrows };

    return (

      <div>
        <Row>
          <Col xs="12" sm="12" md="12" lg="12" xl="12">
            <Card>
              <CardHeader>
                Search Details
              </CardHeader>

              <CardBody className=" paddingBottom">
                <div className="form-group paddingBottom">
                  <Row>
                    {
                      this.props.usr_obj.userRoles === "SYS_ADMIN" ?
                        <Col xs={5}>
                          <LabelDropdown
                            disabled={this.state.spin}
                            tagText={"Corporates"}
                            placeholder={"Select Corporate"}
                            options={corporate_options}
                            value={this.state.corporate_id}
                            onChange={this.corporateHandler("corporate_id")}
                          />
                        </Col> : null
                    }
                    <Col xs={4}>
                      <RangePicker
                        className={"rangepicker-super-meeting-report_"}
                        size={"mini"}
                        defaultValue={[moment().subtract(30, "days"), moment().subtract(0, "days")]}
                        disabledDate={disabledDate}
                        format="YYYY-MM-DD"
                        onChange={this.onChange}
                      />
                    </Col>
                    {
                      this.props.usr_obj.userRoles === "SYS_ADMIN" ?
                        <Col>
                          <Button.Group className={"dual-btn-rangepicker-corp-sms-report"}>
                            <Button positive onClick={() => this.buttonHandler()}>Search</Button>
                          </Button.Group>
                        </Col> : null
                    }
                  </Row>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col lg="12">
            <Card className="card margin0">
              <CardHeader>
                Success Visitor Details
                <Download data={this.state.visitors_list} userType={"LOGIN_HISTORY"} />
              </CardHeader>
              <CardBody>
                <Row>
                  <Col lg="12">
                    {/* {
                      this.state.visitors_list.length !== 0 ? */}
                        <MDBDataTable
                          id={"history-table"}
                          responsive
                          responsiveSm
                          responsiveMd
                          responsiveLg
                          responsiveXl
                          bordered
                          hover
                          data={data} />
                        {/* :
                        <div className={"align-center fully-width"}>
                          <Empty description={"Records not found"} className={"empty-icon"} />
                          <br />
                        </div>
                    } */}


                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <br></br>
        <Row>
          <Col lg="12">
            <Card className="card margin0">
              <CardHeader>
                Failed Visitor Details
                <Download data={this.state.failed_list} userType={"LOGIN_HISTORY"} />
              </CardHeader>
              <CardBody>
                <Row>
                  <Col lg="12">
                    {/* {
                      this.state.failed_list.length !== 0 ? */}
                        <MDBDataTable
                          id={"history-table"}
                          responsive
                          responsiveSm
                          responsiveMd
                          responsiveLg
                          responsiveXl
                          bordered
                          hover
                          data={faileddata} />
                        {/* :
                        <div className={"align-center fully-width"}>
                          <Empty description={"Records not found"} className={"empty-icon"} />
                          <br />
                        </div>
                    } */}


                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  visitors: state.viewAllCheckIN.visitors,
  checkInVisitors: state.viewAllCheckIN.checkInVisitors,
  historyColumns: state.viewAllCheckIN.historyColumns,
  column: state.viewAllCheckIN.column,

  usr_obj: state.userReducer.user,
});

const mapDispatchToProps = (dispatch) => {
  return {
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
